<template>
    <div class="project-phone-agreement">
        <div class="open-wrapper pointer" @click="openModal">
            <slot>
                <a href="javascript://void(0)">
                    <span>Show Phone Script</span>
                </a>
            </slot>
        </div>

        <modal :name=modalId
               :adaptive="true"
               :scrollable="true"
               width="80%"
               height="auto">
            <button type="button" class="close" @click="closeModal"></button>

            <div class="dashboard-block" :class="{loading: loading}">
                <fieldset>
                    <legend>Resident Enrollment Verification Script</legend>

                    <div class="form-group important">
                        <p>Verify the following information:</p>

                        <ul class="list-unstyled">
                            <li v-if="accountable.unit">
                                Verify apartment number: <b>{{accountable.unit}}</b>
                            </li>

                            <li>
                                Caller must be lease holder or spouse, if not, then take note and leave a message for
                                lease holder.
                            </li>
                        </ul>

                        <div class="row">
                            <div class="col-sm-6 col-md-4 form-group" v-for="subject in subjects">
                                <dl class="no-margin">
                                    <dt>Full Name</dt>
                                    <dd>{{subject.fullName}}</dd>

                                    <dt>Email</dt>
                                    <dd>{{subject.contactEmail}}</dd>

                                    <dt v-if="subject.fullAddress">Address</dt>
                                    <dd v-if="subject.fullAddress">
                                        {{subject.fullAddress}}
                                    </dd>

                                    <dt v-if="subject.displayContactPhone">Phone</dt>
                                    <dd v-if="subject.displayContactPhone">{{subject.displayContactPhone}}</dd>
                                </dl>
                            </div>
                        </div>
                    </div>

                    <div class="row form-group">
                        <div class="col-sm-6 col-md-5 pull-right">
                            <div class="btn-group btn-group-justified">
                                <label class="btn btn-success  btn-xs"
                                       :class="{ active: lang === 'en' }">
                                    <input autocomplete="off"
                                           class="form-control"
                                           type="radio"
                                           :value="'en'"
                                           v-model="lang">
                                    English
                                </label>
                                <label class="btn btn-info btn-xs"
                                       :class="{ active: lang === 'es' }">
                                    <input autocomplete="off"
                                           class="form-control"
                                           type="radio"
                                           :value="'es'"
                                           v-model="lang">
                                    Spanish
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="agreement-wrapper">
                        <p v-if="lang === 'en'">
                            Please listen carefully to the following information, this call will be recorded:
                        </p>
                        <p v-else>
                            Por favor escuche atentamente a la siguiente información, su llamada será grabada:
                        </p>

                        <div v-if="model.html" v-html="model.html"></div>

                        <br>

                        <p v-if="lang === 'en'">
                            To finish, please answer Yes or No to the following questions:
                        </p>
                        <p v-else>
                            Para finalizar, por favor responda Si o No a las siguientes preguntas:
                        </p>

                        <ul>
                            <li v-if="lang === 'en'">
                                Do you understand that you are verbally agreeing to enroll in the
                                <span v-if="model.account">{{model.account.project.name}} {{model.account.project.brand_suffix}}</span>?
                            </li>
                            <li v-else>
                                Entiende que está verbalmente aceptando a registrarse en el Programa Bulk?
                            </li>

                            <li v-if="lang === 'en'">
                                Do you understand everything that we have covered on this call?
                            </li>
                            <li v-else>
                                Entiende todo lo que hemos cubierto en esta llamada?
                            </li>
                        </ul>

                        <p v-if="lang === 'en'">
                            Thank you for your time. I will send you a copy of the Media Amenity Contract to the email
                            you provided. If you have any additional questions or concerns, please let us know.
                        </p>
                        <p v-else>
                            Gracias por su tiempo. Le enviaré una copia del contrato al email que usted nos facilitó. Si tiene alguna pregunta adicional o preocupación, por favor háganos saber.
                        </p>
                    </div>
                </fieldset>
            </div>
        </modal>
    </div>
</template>

<script>
    import model from "./mixins/model";

    export default {
        mixins: [ model ],

        props: {
            accountId: {
                type: String,
            },

            accountable: {
                type: Object,
                required: true
            },

            enAgreementId: {
                type: String,
                required: true
            },

            esAgreementId: {
                type: String,
                required: true
            },

            projectId: {
                type: String,
                required: true
            },
        },

        computed: {
            accountableType(){
                if( this.accountable.email ){
                    return 'App\\User';
                }
                else {
                    return 'App\\Lease';
                }
            },

            agreementId(){
                if( this.lang === 'en' ){
                    return this.enAgreementId;
                }
                else {
                    return this.esAgreementId;
                }
            },

            resourceKey(){
                return 'AccountAgreement';
            },

            subjects(){
                if( _.isArray( this.accountable.residents ) ){
                    return this.accountable.residents;
                }
                else {
                    return [ this.accountable ];
                }
            },

            url(){
                return '/api/agreements/' + this.agreementId + '/preview?project_id=' + this.projectId +
                    '&accountable_type=' + this.accountableType +
                    '&accountable_id=' + this.accountable.id;
            },
        },

        watch: {
            lang(){
                this.init();
            }
        },

        methods: {
            getModelData(){
                return {
                    lang: 'en'
                };
            },
        }
    }
</script>
